import { render, staticRenderFns } from "./VRadioButton.vue?vue&type=template&id=5b22e97d&scoped=true"
import script from "./VRadioButton.vue?vue&type=script&lang=js"
export * from "./VRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b22e97d",
  null
  
)

export default component.exports